<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2023-02-05 20:55:24
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <MainNav />
        <div class="main_box">
            <el-main>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">
                        首頁
                    </el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/GoodList' }">
                        商品搜索 - {{ search }}
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div v-loading="isLoading" class="shop_list_con">
                    <ul v-if="goods_data">
                        <li v-for="item in goods_data" :key="item.id">
                            <div class="good_box">
                                <div class="good_box_2">
                                    <div class="good_top">
                                        <router-link :to="`/Good?id=${item.id}`" target="_blank">
                                            <img :src="item.image">
                                        </router-link>
                                    </div>
                                    <div class="good_name">
                                        <router-link :to="`/Good?id=${item.id}`" target="_blank">
                                            {{ item.name }}
                                        </router-link>
                                    </div>
                                    <div class="good_price">
                                        <label>₩ </label><span>{{ amountFormatte(item.price) }}</span>
                                    </div>
                                    <div class="other">
                                        <div class="postage">
                                            {{ `${item.weight} KG/件` }}
                                        </div>
                                    </div>
                                    <router-link class="btn2" :to="`/Good?id=${item.id}`" target="_blank">
                                        查看詳情
                                    </router-link>
                                    <el-button v-if="item.status" class="btn3" @click="show_cart(item)">
                                        加入購物車
                                    </el-button>
                                    <el-button v-else disabled class="disable_btn">
                                        該商品缺貨
                                    </el-button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="no_goods_box">
                        <img src="../../public/img/no_goods.png">
                    </div>
                    <el-pagination background layout="prev, pager, next" :hide-on-single-page="true" :total="total"
                        :page-size="page_num" :current-page="page" @current-change="ChangePage">
                    </el-pagination>
                </div>
            </el-main>
        </div>
        <MainFooter />
        <el-dialog width="34%" :title="dialog_title" :visible.sync="dialogFormVisible">
            <div class="dialog_box">
                <img :src="dialog_img">
                <el-form ref="formValidate" :model="add_form" :rules="ruleValidate" label-width="90px"
                    label-position="left">
                    <el-form-item v-for="(item, index) in dialog_attr_name" :key="index + 100" :label="item" size="medium"
                        :prop="'attr.' + item">
                        <el-radio-group v-model="add_form.attr[item]" size="mini" @change="$forceUpdate()">
                            <el-radio-button v-for="(ritem, rindex) in dialog_attr_value[index]" :key="rindex + 1000"
                                v-model="add_form.attr[item]" :label="ritem"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="購買數量" prop="num">
                        <el-input-number v-model="add_form.num" :min="1" size="mini"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="def_btn" @click="dialogFormVisible = false">
                    取 消
                </el-button>
                <el-button v-if="add_form.status" class="common_btn" type="primary" @click="Add_Shopcart()">
                    加入購物車
                </el-button>
                <el-button v-else disabled class="common_btn disable_btn">
                    該商品缺貨
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import MainNav from "@/components/MainNav";
import MainFooter from "@/components/Footer";
import { search_goods } from "@/api/goodsAPI";
import { filter_info } from "@/api/basicAPI";
import { ImagePath } from "@/config/serverPath";
import { changeImage, changeAttrVal, amountFormatte } from "@/utils";
import { add_cart } from "@/api/dataAPI";
// 辅助函数，可以使用命名空间获取$store的数据
import { mapState } from "vuex";
export default {
    components: {
        MainHeader,
        MainNav,
        MainFooter,
    },
    data () {
        return {
            search: "",
            image_path: ImagePath,
            goods_data: [], // 商品列表
            total: null,
            page_num: 16, // 每页显示个数
            page: null, // 当前页数
            isLoading: false, // 是否加载中
            dialogFormVisible: false, // 加入购物车弹框
            add_form: {
                id: null, // 商品ID
                num: 1, // 购买数量
                attr: {}, // 购买属性
            },
            dialog_title: "", // 弹出框商品名称
            dialog_price: 0, // 弹出框商品价格
            dialog_attr_name: [], // 弹出框属性名称
            dialog_attr_value: [], // 弹出框属性值
            dialog_img: "", // 弹出框图片
            ruleValidate: {
                num: [
                    {
                        required: true,
                        message: "數量不能為空",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {
        ...mapState("BasicInfo", ["basic_info"]),
        ...mapState("loginUser", ["user_data"]),
    },
    watch: {
        // 监控数据的变化，当某些数据变化时，需要做的事情，比如页面传递过来的ID等等
        // 可以用简单写法   '$route.params.id'(){ doSomething.. }
        "$route.query": {
            immediate: true, // 第一次的数据，也要当做是一种变化
            // 处理函数（不能修改名字） handler('新的值'，'旧的值')
            handler () {
                this.search = this.$route.query.search
                    ? this.$route.query.search
                    : "";
                this.page = this.$route.query.page
                    ? Number(this.$route.query.page)
                    : 1;
                this.get_search_data(this.search, this.page, this.page_num);
            },
        },
    },
    methods: {
        amountFormatte,
        // 获取商品数据
        async get_search_data (search, page, page_num) {
            this.isLoading = true;
            if (search) {
                let res = await search_goods(search, page, page_num);
                if (res.goods_data.length != 0) {
                    this.goods_data = changeImage(
                        250,
                        250,
                        res.goods_data,
                        "thumb"
                    );
                    this.total = res.total;
                    this.goods_data.forEach((ele, index) => {
                        this.goods_data[index].attribute_name =
                            ele.attribute_name.split("/");
                        this.goods_data[index].attribute_value = changeAttrVal(
                            ele.attribute_value
                        );
                    });
                } else {
                    this.goods_data = null;
                }
            } else {
                this.$message({
                    type: "error",
                    message: "请输入您要查询的商品",
                    center: true,
                });
            }
            this.isLoading = false;
        },
        // 修改页数
        ChangePage (val) {
            this.get_search_data(this.search, val, this.page_num);
        },
        // 展开添加购物车
        show_cart (data) {
            this.add_form.id = data.id;
            this.add_form.attr = {};
            this.add_form.num = 1;
            this.add_form.status = data.status;
            this.dialog_title = data.name;
            this.dialog_price = data.price;
            this.dialog_attr_name = data.attribute_name;
            this.dialog_attr_value = data.attribute_value;
            this.dialog_img = data.image;
            this.dialogFormVisible = true;

            this.dialog_attr_value.forEach((ele, index) => {
                this.add_form.attr[this.dialog_attr_name[index]] = ele[0];
            });
        },
        // 添加购物车
        Add_Shopcart () {
            if (!this.user_data) {
                this.$router.push({ name: "Login" });
            } else {
                this.$refs["formValidate"].validate(async (val) => {
                    if (val) {
                        // 加入购物车
                        let resp = await add_cart(
                            this.add_form.id,
                            this.add_form.num,
                            this.add_form.attr
                        );
                        switch (resp.OPStatus) {
                            case true:
                                this.$message({
                                    type: "success",
                                    message: "商品添加成功",
                                    center: true,
                                });
                                break;
                            case "note":
                                this.$message({
                                    type: "error",
                                    message: resp.msg,
                                    center: true,
                                });
                                break;
                            case "Login":
                                this.$message({
                                    type: "error",
                                    message: resp.msg,
                                    center: true,
                                });
                                this.$router.push({ name: "Login" });
                                break;
                            default:
                                console.log(resp);
                                break;
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: "請選擇商品屬性並填寫數量",
                            center: true,
                        });
                    }
                });
                this.dialogFormVisible = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.dialog_box {
    padding: 0 20px;

    img {
        display: block;
        margin: 15px auto 30px auto;
    }
}

::v-deep .el-dialog__body {
    padding: 0 20px;
}

::v-deep .el-radio-button__inner:hover {
    color: #ff3c5c;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #ff3c5c;
    border-color: #ff3c5c;
    box-shadow: -1px 0 0 0 #ff3c5c;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner:hover {
    color: #fff;
}

.main_box {
    width: 1240px;
    margin: 0 auto;

    .el-main {
        width: 1240px;
        padding: 0;
        background-color: #fff;

        .el-breadcrumb {
            margin: 10px 0 20px 0;
        }

        .filter_box {
            margin-top: 11px;
            position: relative;
            border: 1px solid #e8e8e8;
            height: auto;
            overflow: hidden;

            .filter {
                position: relative;
                border-top: 1px dashed #dedede;
                margin: 0 8px;
                clear: both;

                .title {
                    position: absolute;
                    left: 11px;
                    top: 9px;
                    color: #999;

                    span {
                        float: left;
                        max-width: 80px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .con {
                    padding: 0 50px 0 112px;

                    .filter_brand {
                        padding-top: 10px;
                        margin-bottom: 10px;
                        height: auto;
                        overflow: hidden;
                        zoom: 1;

                        li {
                            float: left;
                            display: inline;
                            width: 116px;
                            height: 72px;
                            padding: 0;
                            border: 1px solid #ddd;
                            margin: -1px -1px 0 0;
                            background: #fff;
                            text-align: center;

                            a {
                                display: block;
                                border: 1px solid #fff;
                                height: auto;
                                width: 114px;
                                overflow: hidden;
                                margin: 0px;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                zoom: 1;
                                color: #ff2832;
                                line-height: 64px;

                                img {
                                    padding: 5px 6px;
                                    vertical-align: top;
                                }
                            }
                        }
                    }
                }

                .l_a {
                    a {
                        float: left;
                        margin: 2px 10px 2px 0;
                        height: 20px;
                        line-height: 20px;
                        color: #000;
                        padding: 3px 12px;
                        border: 1px solid #ffffff;
                        text-decoration: none;
                    }
                }

                a:hover,
                .router-link-exact-active {
                    position: relative;
                    border: 1px solid #ff2832 !important;
                }
            }

            .filter:first-child {
                border-top: none;
            }
        }

        .shop_list_con {
            padding: 0 0 20px 0;
            height: auto;
            overflow: hidden;

            ul {
                height: auto;
                overflow: hidden;
                padding: 30px 0 30px 30px;

                li {
                    position: relative;
                    float: left;
                    display: inline;
                    width: 272px;
                    height: 434px;
                    margin: 0 30px 0 0;

                    .good_box {
                        background-color: #fff;
                        width: 240px;
                        height: 430px;
                        border: 1px solid #fff;
                        -webkit-transition: border-color 0.2s ease-in;
                        -moz-transition: border-color 0.2s ease-in;
                        -ms-transition: border-color 0.2s ease-in;
                        -o-transition: border-color 0.2s ease-in;
                        transition: border-color 0.2s ease-in;
                        zoom: 1;
                    }

                    .good_box_2 {
                        width: 240px;
                        height: 410px;

                        .btn2 {
                            clear: both;
                        }

                        .btn2,
                        .btn3 {
                            width: 110px;
                            height: 30px;
                            float: left;
                            color: #fff;
                            display: block;
                            overflow: hidden;
                            font-size: 16px;
                            text-align: center;
                            line-height: 30px;
                            margin-top: 10px;
                            background-color: #409eff;
                            border-radius: 4px;
                            padding: 0;
                            border: none;
                        }

                        .btn3 {
                            float: right;
                            background-color: #ff2832;
                        }
                    }
                }

                li:hover {
                    z-index: 200;

                    .good_box {
                        position: absolute;
                        border: solid 1px #fff;
                        height: auto;
                        width: 256px;
                        right: -17px;
                        top: 0;
                        left: -16px;
                        z-index: 210;
                        box-shadow: 4px 4px 20px #c6c6c6;
                        padding-right: 17px;
                        background-color: #fff;
                    }

                    .good_box_2 {
                        float: right;
                        width: 240px;
                        display: inline;
                        background: #fff;
                        padding-bottom: 10px;
                    }
                }

                .good_top {
                    height: auto;
                    position: relative;

                    .tit {
                        position: absolute;
                        left: 0;
                        top: 15px;
                        height: 70px;
                        z-index: 5;

                        b {
                            color: #ff2832;
                        }
                    }

                    a {
                        display: block;
                        overflow: hidden;
                        padding-top: 17px;

                        img {
                            display: block;
                            margin: 0 auto;
                            width: 240px;
                            height: auto;
                        }
                    }
                }

                .good_name {
                    width: 200px;
                    padding: 12px 10px 0;
                    overflow: hidden;
                    height: 35px;
                    font-size: 12px;
                    line-height: 18px;
                    zoom: 1;
                    font-family: "宋体";

                    a {
                        color: #444;
                    }

                    a:hover {
                        color: #ff2832;
                    }
                }

                .good_price {
                    height: 32px;
                    margin-top: 2px;
                    position: relative;
                    margin: 3px 0 0;
                    color: #f42468;
                    font-family: arial;

                    label {
                        font-size: 18px;
                        font-family: arial;
                    }

                    span {
                        font-size: 24px;
                    }
                }

                .other {
                    width: 257px;
                    height: 20px;
                    margin: 0 auto;
                    margin-top: 2px;

                    .postage {
                        display: inline-block;
                        color: #787878;
                        padding-right: 5px;
                        float: left;
                    }
                }
            }

            .el-pagination {
                text-align: center;
            }

            ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #ff2832;
            }

            ::v-deep .el-pagination.is-background .el-pager li:hover {
                color: #ff2832;
            }

            ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
                color: #fff;
            }

            .no_goods_box {
                text-align: center;
                margin-top: 20px 0;

                img {
                    width: 500px;
                }
            }
        }
    }

    .disable_btn {
        width: 110px;
        height: 30px;
        float: right;
        display: block;
        overflow: hidden;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        margin-top: 10px;
        border-radius: 4px;
        padding: 0;
    }
}
</style>
